import styled from 'styled-components';

export const Container = styled.div<any>`
  width: 100%;
  height: calc(100% - 2rem);
  display: flex;
  flex-direction: row;
`;
